import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label-error-container"
}
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["value", "disabled", "readonly", "required", "autocomplete", "min", "max", "maxlength", "step", "type", "placeholder"]
const _hoisted_5 = { class: "input-group-text" }
const _hoisted_6 = {
  key: 3,
  class: "stepper noselect"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_popover = _resolveComponent("popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label || _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['b-form-input', {'input-group': _ctx.hasAppendGroup || _ctx.hasPrefixGroup || _ctx.moreInfo}])
    }, [
      (_ctx.hasPrefixGroup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['input-group-text', {'padding-0': _ctx.hasPrefixGroupSlot}])
          }, [
            _renderSlot(_ctx.$slots, "appendPrefixGroup", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.appendPrefixGroup), 1)
            ], true)
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(), _createElementBlock("input", {
        ref: "input",
        key: _ctx.state.componentKey,
        value: _ctx.modelValue,
        disabled: _ctx.isDisabled,
        readonly: _ctx.readonly,
        required: _ctx.required,
        autocomplete: _ctx.autocomplete || null,
        min: _ctx.min,
        max: _ctx.max,
        maxlength: _ctx.maxlength,
        step: _ctx.step,
        type: _ctx.type,
        class: _normalizeClass(['form-control', {'readonly': _ctx.readonly}]),
        placeholder: _ctx.placeholder,
        "aria-label": "Username",
        "aria-describedby": "basic-addon1",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event))),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange($event))),
        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onKeyPress($event))),
        onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onKeyDown($event))),
        onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        style: _normalizeStyle(_ctx.getValidity())
      }, null, 46, _hoisted_4)),
      (_ctx.hasAppendGroup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['input-group-text', {'padding-0': _ctx.hasAppendGroupSlot}])
          }, [
            _renderSlot(_ctx.$slots, "appendGroupText", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.appendGroupText), 1)
            ], true)
          ], 2))
        : (_ctx.moreInfo)
          ? (_openBlock(), _createBlock(_component_popover, {
              key: 2,
              "use-mouse-position": ""
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.moreInfo), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-info" })
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      (_ctx.showStepper)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "step",
              onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.numberChange(-1))),
              onMouseup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("span", null, "-", -1)
            ]), 32),
            _createElementVNode("div", {
              class: "step",
              onMousedown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.numberChange(1))),
              onMouseup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("span", null, "+", -1)
            ]), 32)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}